import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import NFTLoanHero from "./NFTLoanHero";
import PopularityOfNFTs from "./PopularityOfNFTs";
import UniqueDigitalArts from "./UniqueDigitalArts";
import Ownership from "./Ownership";
import ConceptualizationNFT from "./ConceptualizationNFT";
import WhyChoose from "../../Wallet/NFT Wallet/WhyChoose";

function NFTLoan() {
  return (
    <div>
      <Header />
      <NFTLoanHero />
      <PopularityOfNFTs />
      <UniqueDigitalArts />
      <Ownership />
      <ConceptualizationNFT />
      <WhyChoose />
      <Footer />
    </div>
  );
}

export default NFTLoan;
